<template>
    <div class="block-editor create-task">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t("message.title") }}</div>
            <TiptapEditor
                :placeholder="$t('message.title')"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.title"
            />
        </div>
        <div class="editor-row customize-editor">
            <div class="editor-row-title">{{ $t("message.description") }}</div>
            <TiptapEditor
                :placeholder="$t('message.description')"
                :show-attributes="true"
                :max-character-count="2048"
                v-model="clone.description"
            />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">{{ $t("message.priority") }}</div>
            <a-select
                class="classic-new-select"
                :placeholder="$t('message.priority')"
                v-model:value="clone.priority"
                :options="priority"
            />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">{{ $t("message.workflow") }}</div>
            <a-select
                class="classic-new-select"
                :placeholder="$t('message.workflow')"
                v-model="clone.workflowId"
                :options="workflows"
            />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">{{ $t("message.pipelineStage") }}</div>
            <a-select
                :disabled="!clone.workflowId"
                class="classic-new-select"
                :placeholder="$t('message.pipelineStage')"
                v-model="clone.pipelineStageId"
                :options="pipelines"
            />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">{{ $t("message.owner") }}</div>
            <a-select
                class="classic-new-select"
                :placeholder="$t('message.owner')"
                v-model="clone.ownerId"
                :options="users"
            />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">{{ $t("message.assignees") }}</div>
            <a-select
                class="classic-new-select"
                :placeholder="$t('message.assignees')"
                v-model="clone.assigneeIds"
                mode="multiple"
                :options="users"
            />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapActions, mapState } from "vuex";

const log = log2("CreateTask");
export default {
    name: "CreateTask",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            pipelines: [],
        };
    },
    computed: {
        priority() {
            return [
                { value: "low", label: this.$t("task.low") },
                { value: "medium", label: this.$t("task.medium") },
                { value: "high", label: this.$t("task.high") },
            ];
        },
        ...mapState({
            defaultWorkflow: (state) => state.tasks.defaultWorkflow,
            users: (state) =>
                state.user.users.data.map((user) => ({
                    value: user._id,
                    label: `${user.name} (${user.email})`,
                })),
            workflows: (state) =>
                state.tasks.workflows.map((workflow) => ({
                    value: workflow._id,
                    label: workflow.title,
                    pipelines: workflow.pipeline,
                })),
        }),
    },
    methods: {
        ...mapActions({}),
    },
    mounted() {
        if (this.clone.workflowId) {
            const workflow = this.workflows.find((w) => w.value === this.clone.workflowId);
            this.pipelines = workflow.pipelines.map((pipeline) => ({
                value: pipeline._id,
                label: pipeline.name,
            }));
        }
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                if (this.clone.workflowId) {
                    const workflow = this.workflows.find((w) => w.value === this.clone.workflowId);
                    this.pipelines = workflow.pipelines.map((pipeline) => ({
                        value: pipeline._id,
                        label: pipeline.name,
                    }));
                }
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.create-task {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;
    .editor-row {
        width: 100%;
        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
    .classic-new-select {
        width: 100%;
        font-weight: bold;
        [role="combobox"] {
            padding: 4px;
            border: none !important;
            border-radius: 4px !important;
            background-color: #f1f1f1 !important;
        }
    }
    .customize-editor {
        &-minimize {
            .editable-editor {
                background-color: #6c757d;
                .ProseMirror {
                    color: white;
                }
            }
        }
        .editable-editor {
            background-color: #6c757d;
            .ProseMirror {
                color: white;
                height: 100px;
            }
        }
    }
}
</style>
